import React, {useEffect, useState} from "react";
import cx from "classnames"
import styles from "./HoverLink1.module.css"
import Link from "next/link";
import {useRouter} from "next/router";

const HoverLink1 = ({link, linkTitle, target="_blank"}) => {
    const [isEn, setIsEn] = useState(false)
    const router = useRouter()

    useEffect(() => {
        if (router.pathname.includes("/en")) {
            setIsEn(true)
        } else {
            setIsEn(false)
        }
    }, [router])
    return(
        <Link target={target} className={cx(styles.topicLink, "mt-3", isEn ? "gilroyFontFamily" : "")} href={link}>
            <span>{linkTitle}</span>
        </Link>
    )
}
export default HoverLink1